import React from "react";

const Mouse = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M16.505 2h2.768c3.245 0 4.985.445 6.56 1.282a8.754 8.754 0 0 1 3.654 3.628c.843 1.565 1.29 3.293 1.29 6.516v9.148c0 3.223-.447 4.95-1.29 6.516a8.754 8.754 0 0 1-3.654 3.628c-1.575.837-3.315 1.282-6.56 1.282h-2.77c-3.244 0-4.984-.445-6.56-1.282a8.754 8.754 0 0 1-3.654-3.628C5.448 27.525 5 25.797 5 22.574v-9.15c0-3.222.448-4.95 1.29-6.515a8.754 8.754 0 0 1 3.656-3.627C11.52 2.445 13.26 2 16.505 2Zm-.227 6.4v8H19.5v-8h-3.222Z"
            fill={fill}
        />
    </svg>
);

export default Mouse;